import { highlightItems } from '@/mocks/anime';

export default function HighlightStrip() {
  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-8 md:py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {highlightItems.map((item) => (
            <div
              key={item.title}
              className="flex items-start gap-3 rounded-lg bg-background-50 border border-background-200 p-4"
            >
              <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}